import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { USER_STATUS } from '@/views/Facilities/UserManagement/components/userHistory.utils';

const STATUS_CONFIG = {
  [USER_STATUS.ACTIVE]: {
    color: 'success',
    translationKey: 'facilityUserManagement.status.active',
  },
  [USER_STATUS.INACTIVE]: {
    color: 'default',
    translationKey: 'facilityUserManagement.status.inactive',
  },
  [USER_STATUS.ONBOARDING]: {
    color: 'warning',
    translationKey: 'facilityUserManagement.status.onboarding',
  },
};

const FacilityUserStatusChip = ({ status }) => {
  const { t } = useTranslation();

  const config = STATUS_CONFIG[status] || STATUS_CONFIG[USER_STATUS.INACTIVE];

  return (
    <Chip
      label={t(config.translationKey)}
      size='small'
      color={config.color}
      variant='outlined'
    />
  );
};

export default FacilityUserStatusChip;
